import * as React from "react";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkCheckbox } from "uitk-react-switch";
import { DifferentDropOffToggleProps } from "../typings";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";

export const DifferentDropOffToggle: React.FunctionComponent<DifferentDropOffToggleProps> = ({
  onDifferentDropOffSelected,
  isDiffDropOff,
}) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutGridItem colSpan="all">
      <div>
        <UitkCheckbox
          id="diff-drop-of-toggle"
          label={formatText(locKeys.differentDropOff)}
          checked={isDiffDropOff}
          onChange={onDifferentDropOffSelected}
          data-testid="diff-drop-of-toggle"
        />
      </div>
    </UitkLayoutGridItem>
  );
};
